import { createContext, useContext } from 'react';

/**
 * Who is on the page (grid cells and the unplaced pool), for the avatar
 * enter/exit animations.
 *
 * - `present`: everyone shown right now. An avatar leaving a cell whose person
 *   is still present elsewhere glides there (shared layout); one whose person
 *   is gone shrinks away.
 * - `entering`: people who were not shown before this render, e.g. after
 *   switching to a day on which someone was placed for the first time. Their
 *   avatar grows in instead of gliding from nowhere.
 */
export type TalentReviewPresence = {
	present: ReadonlySet<string>;
	entering: ReadonlySet<string>;
};

const EMPTY: TalentReviewPresence = { present: new Set(), entering: new Set() };

export const TalentReviewPresenceContext = createContext<TalentReviewPresence>(EMPTY);

export const useTalentReviewPresence = () => useContext(TalentReviewPresenceContext);
